export default __webpack_public_path__ + "static/avatar_9-6b74494597bef646d697b69b917e62b8.svg";